export let composeEllipsisAriaLabelText = "XM6qnb";
export let encryptMenuText = "jSnsFb";
export let encryptDisableForwardingMenuText = "emiqU";
export let hideFrom = "Gs4hvc";
export let switchToHTMLMenuItem = "QdkAee";
export default {composeEllipsisAriaLabelText,encryptMenuText,encryptDisableForwardingMenuText,hideFrom,switchToHTMLMenuItem};